
  import { defineComponent } from 'vue';
  import { Box } from '@/ui/components/Box';

  export default defineComponent({
    components: { Box },
    emits: ['add-widget'],
    setup(_, { emit }) {
      const click = () => emit('add-widget');

      return {
        click,
      };
    },
  });
